module.exports = __webpack_public_path__ + "static/media/ionicons.71148788.svg";